import { TenantPolicy } from '@activepieces/shared'

import { api } from '@/lib/api'

export const policyApi = {
  get(): Promise<TenantPolicy> {
    return api.get<TenantPolicy>('/v1/policy')
  },
}
